import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GatePassAccociateInformation } from "../gatepass-request-process.model";
import { GatePassRequestsService } from "../../gate-pass-requests.service";

@Component({
  selector: 'app-associate-covered-under',
  templateUrl: './associate-covered-under.component.html',
  styleUrls: ['./associate-covered-under.component.css']
})
export class AssociateCoveredUnderInformationSelectionComponent implements OnInit {

  @Input() public isContractor: boolean;
  @Input() public stepData: any;

  @Output() public handleSave: EventEmitter<GatePassAccociateInformation>;
  @Output() public handleClose: EventEmitter<void>;
  @Output() public handlePrevAction: EventEmitter<void>;

  public currentStep: number = 1;

  public formGroup: FormGroup;

  constructor(
    private fb: FormBuilder,
    public gatepassService: GatePassRequestsService
  ) {
    this.handleSave = new EventEmitter<GatePassAccociateInformation>();
    this.handleClose = new EventEmitter<void>();
    this.handlePrevAction = new EventEmitter<void>();
    this.formGroup = this.buildFormGroup();
  }

  public ngOnInit(): void {
    if (this.stepData) {
    this.gatepassService.getRequestTypeText(this.stepData);
      this.formGroup.patchValue({ ...this.stepData });
    }
  }

  public onNextAction(): void {
    this.handleSave.emit(this.formGroup.getRawValue());
  }

  public onPrevAction(): void {
    this.handlePrevAction.emit();
  }

  public onCloseAction(): void {
    this.handleClose.emit();
  }

  private buildFormGroup(): FormGroup {
    return this.fb.group({
      labourCoverType: ['', [Validators.required]]
    })
  }

}